exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".room-gallery {\n  -ms-flex-item-align: stretch;\n      align-self: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: column;\n          flex-flow: column;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 100%;\n  background-color: #e0e0e0; }\n  .room-gallery > div {\n    max-width: calc(100% - 40px);\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    margin-bottom: 20px; }\n  .room-gallery .title {\n    font-weight: 400; }\n  .room-gallery .card-label {\n    font-size: .9em;\n    font-weight: 500;\n    margin: 0; }\n  .room-gallery__header {\n    height: 100%;\n    margin-top: 20px;\n    line-height: 1.2;\n    text-align: center; }\n  .room-gallery__inner {\n    padding: 15px;\n    background: #fff; }\n    .room-gallery__inner.available {\n      background-color: #fff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-gallery/room-gallery.component.scss
// module id = ../../../../../src/app/room-availability/room-gallery/room-gallery.component.scss
// module chunks = main